// ======================================================================
// File Name       : SentMessageListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import moment from 'moment';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import SentMessageSearch from '../../components/messageThread/SentMessageSearch';
import SentMessageList from '../../components/messageThread/SentMessageList';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import { RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../../constants/MessageThreadContants';
import { SENT_MESSAGE_LIST, SENT_MESSAGE_THREAD_DETAIL } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import * as ICON from '../../constants/IconConstants';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class SentMessageListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageSortType: 8,
      startPosition: 0,
      ascendingDescendingSort: 0,
      isAllowShowSearchMessage: false,
    };
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.searchData = this.searchData.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    this.initData();
  }

  goToDetail(messageIdAuto) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: SENT_MESSAGE_LIST,
        searchCondition: formValues,
      });
    }
    const path = SENT_MESSAGE_THREAD_DETAIL.replace(':id', messageIdAuto);
    this.props.history.push(path);
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.messageSortType) {
        column = initialValues.messageSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues);
    this.props.dispatch(MessageThreadAction.getSentMessageList(param));
  }

  searchData(startPosition, column) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition, column);
    this.props.dispatch(MessageThreadAction.getSentMessageList(param)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.searchData(0);
  }

  downloadAttachment(item) {
    if (item && Object.keys(item).length) {
      if (isNaN(parseInt(item.messageType, 10)) || !item.messageIdAuto) {
        return;
      }
      const param = {};
      param.messageType = item.messageType;
      param.messageIdAuto = item.messageIdAuto;
      this.props.dispatch(MessageThreadAction.downloadMessageAttachment(param));
    }
  }

  createParams(searchInfo, startPosition, column) {
    const param = {};
    param.messageType = MESSAGE_TYPE.ROUTE;
    const paramSearchInfo = {};
    paramSearchInfo.messageSortType = this.state.messageSortType;
    paramSearchInfo.sentReceivedMessageFilter = MESSAGE_FILTER.SENT;
    if (searchInfo && Object.keys(searchInfo).length) {
      searchInfo.messageTitle && (paramSearchInfo.messageTitle = searchInfo.messageTitle);
      searchInfo.authorName && (paramSearchInfo.authorName = searchInfo.authorName);
      searchInfo.sentDateFrom &&
        (paramSearchInfo.sentDateFrom = moment(searchInfo.sentDateFrom)
          .startOf('day')
          .format(DEFAULT_DATE_FORMAT_SERVER));
      searchInfo.sentDateTo &&
        (paramSearchInfo.sentDateTo = moment(searchInfo.sentDateTo)
          .endOf('day')
          .format(DEFAULT_DATE_FORMAT_SERVER));
      paramSearchInfo.startPosition = searchInfo.startPosition || 0;
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      paramSearchInfo.ascendingDescendingSort = column.sortState;
      paramSearchInfo.messageSortType = column.sortBy;
    }
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    param.searchInfo = paramSearchInfo;
    return param;
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(startPosition);
  }

  handleSortState(column) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(null, column);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  componentWillUnmount() {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: SENT_MESSAGE_LIST,
        searchCondition: formValues,
      });
    }
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { receiveMessages, recordNum, startPosition, invalid } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={receiveMessages ? receiveMessages.allMessageIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <SentMessageSearch
          onSearchBtnClick={this.onSearchBtnClick}
          startPosition={startPosition}
          invalid={invalid}
        />
        <CustomLink
          className="margin-right-7 btn-register margin-right-10 margin-bottom-10"
          to={Path.REGISTER_MESSAGE_THREAD}
          text="メッセージスレッド新規作成"
          icon={ICON.REGIST}
        />
        <SentMessageList
          receiveMessages={receiveMessages}
          downloadAttachment={this.downloadAttachment}
          recordNum={recordNum}
          getStartEndData={this.getStartEndData}
          startPosition={startPosition}
          invalid={invalid}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { sentMessageListSearchForm } = state.form;
  const { receiveMessages, recordNum } = state.messageThread;
  const { parentPath, searchCondition } = state.page;
  let initial = {};
  if (parentPath === SENT_MESSAGE_LIST) {
    initial = searchCondition;
  }
  return {
    receiveMessages,
    recordNum,
    sentMessageListSearchForm,
    invalid: isInvalid('sentMessageListSearchForm')(state),
    formValues: getFormValues('sentMessageListSearchForm')(state),
    initialValues: initial,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'sentMessageListSearchForm',
    touchOnChange: true,
  })(SentMessageListContainer),
);
